import request from './request';

export function getOpenGraphData(data) {
    return request('get', `/apiv2/open-graph/`, data);
}